import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    padding: 25,
  },
  HEADLINE: {
    textAlign: "center",
    fontSize: "22pt",
    fontFamily: theme.fontFamily,
    // padding: "0 50px",
    // padding: 20,
    fontWeight: "bold" as "bold",
  },
  SUBHEADLINE: {
    textAlign: "center",
    fontSize: "18pt",
    fontFamily: theme.fontFamily,
    marginTop: -20,
    // padding: "0 50px",
    // fontWeight: "bold" as "bold",
  },
  TEXT: {
    textAlign: "center",
    fontFamily: theme.fontFamily,
    fontSize: "13pt",
    lineHeight: "18pt",
    // padding: "20px 0",
  },
};
